export default function PageNotFound() {
  return <div>Page not found</div>;
}
